import Routes from "./routes";
function App() {
  return (
    <div className="w-full-flex">
      <Routes />
    </div>
  );
}

export default App;
